import { Select } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { getCountryCodes, getHighlightedCodes } from "src/utils/countries";
import { CountryCode, getCountryCallingCode } from "libphonenumber-js";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

const { Option } = Select;
export const CountriesDropdown = ({ onChange, countryCode, disabled = false }) => {
	const countries = getCountryCodes();
	const { country_code } = useContext(ConfigStateContext);
	const highlightedCodes = getHighlightedCodes();
	const [selectedCountry, setSelectedCountry] = useState(countryCode);
	const [visible, setVisible] = useState(false);

	const handleChange = value => {
		const selectedCountry = countries.find(country => country.code === value);
		setSelectedCountry(selectedCountry);
		if (onChange) {
			onChange(selectedCountry);
		}
	};

	useEffect(() => {
		const defaultCountryValue = country_code ? getCountryCallingCode(country_code as CountryCode) : "";
		const defaultSelectedCountry = {
			value: `+${defaultCountryValue}`,
			code: country_code,
		}
		if (countryCode && countryCode.value) {
			const selectedCountry = countries.find(country => country.code === countryCode?.code);
			setSelectedCountry(selectedCountry);
		}
		else {
			setSelectedCountry(defaultSelectedCountry)
		}
	}, [countryCode]);

	return (
		<Select
			style={{ width: "100%", zIndex: 999 }}
			placeholder="Seleccione un país"
			onChange={handleChange}
			disabled={disabled}
			className="countries-dropdown-testDani"
			onDropdownVisibleChange={() => setVisible(visible => !visible)}
			value={selectedCountry?.code}>
			{highlightedCodes?.map(country => (
				<Option key={country.key} value={country.code}>
					<span style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
						<img
							alt={country.key}
							src={country.icon}
							width={24}
							height={20}
							className="flag-images"
						/>
						{visible ? country.text : country.value}
					</span>
				</Option>
			))}
			<Option
				value={null}
				style={{
					padding: 0,
					margin: ".6rem 0",
					borderBottom: "1px solid #456787",
					minHeight: "1px",
					position: "relative",
				}}
				disabled>
				{" "}
			</Option>
			{countries.map(country => (
				<Option key={country.key} value={country.code}>
					<span style={{ display: "flex", alignItems: "center", gap: ".4rem" }}>
						<img
							alt={country.key}
							src={country.icon}
							width={24}
							height={20}
							className="flag-images"
						/>
						{visible ? country.text : country.value}
					</span>
				</Option>
			))}
		</Select>
	);
};

